"use client"

import { FileBraces } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FileBracesIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FileBracesIcon = component(Icon)({ as: FileBraces })
